angular.module("digitalLeasing.module").component("genericCheckListDigital", {
  templateUrl: "ng/components/digitalLeasing/checkList/genericCheckListDigital/genericCheckListDigital.view.html",
  bindings: {
    model: "=",
    financialModel: "=",
    showButtonMail: "<",
    checkListDownload: "&",
    restFinish: "<",
    downloadSetCtr: "<",
    printSetContrat: '<',
    recallRestDownload: '&',
    snapshot: '<',
    listDownload: '=',
    groupsGuarantees: '<',
    message: '<'
  },
  controllerAs: "genericCheckListCtrl",
  controller: genericCheckListController,
});

function genericCheckListController(
  $simulationService,
  $configService,
  $portalService,
  $rootScope,
  $modalService,
  $financialApiService,
  $timeout,
  $notificationService,
  FileUploader,
  $download
) {
  var self = this;

  self.$onInit = function () {
    self.listOfInfo = [];
    self.visualProgBarDoc = [];
    if (getWizardMap(self.financialModel.viewIndex) == "M17") {
      self.lastMap = true;
    } else {
      self.lastMap = false;
    }
    self.loadingStatus = {
      uploading: false,
    };
  };

  self.$onChanges = function (changed) {
    if (
      changed.restFinish &&
      typeof changed.restFinish.currentValue != "undefined"
    ) {
      self.waitFromRest = changed.restFinish.currentValue;
      if (!changed.restFinish.currentValue) {
        checkInformative();
        verbaleIsPresentFn();
        garanzieIsPresentFn();
        allDocumentDownloaded();
        everyFileIsDownloaded();
        self.checkStatusOfFile();
        $timeout(function () {
          checkFileDownloaded();
        }, 2);
      }
    }
  };

  self.generdownloadDoc = function (file) {
    var input = {
      downloadKey: file.downloadKey
    }
    var url = "/uni/downloadDocDigital/service-infos/"
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  };

  self.fileIsDownloaded = function (index, file) {
    self.model.documents[index].downloaded = true;
    self.generdownloadDoc(file);
    if (!self.lastMap) {
      var downloadedIsPresent = self.financialModel.leasingData.preventivo.documents.downloaded.some(
        function (e) {
          return e.cdDoc == self.model.documents[index].cdDoc;
        }
      );

      if (!downloadedIsPresent) {
        self.financialModel.leasingData.preventivo.documents.downloaded.push(
          self.model.documents[index]
        );
      }
    } else {
      notifyEvent(self.model.documents[index]);
      if ($portalService.isAru()) {
        var downloadedIsPresent = self.financialModel.leasingData.contratto.documents.downloadedArc.some(
          function (e) {
            return e.cdDoc == self.model.documents[index].cdDoc;
          }
        );

        if (!downloadedIsPresent) {
          self.financialModel.leasingData.contratto.documents.downloadedArc.push(
            self.model.documents[index]
          );
        }
      } else {
        var downloadedIsPresent = self.financialModel.leasingData.contratto.documents.downloaded.some(
          function (e) {
            return e.cdDoc == self.model.documents[index].cdDoc;
          }
        );

        if (!downloadedIsPresent) {
          self.financialModel.leasingData.contratto.documents.downloaded.push(
            self.model.documents[index]
          );
        }
      }
    }

    everyFileIsDownloaded();
  };

  var everyFileIsDownloaded = function () {
    var test =
      self.model.documents &&
      self.model.documents.every(function (element) {
        return element.downloaded == true;
      });
    if (test) {
      self.checkListDownload({
        value: false,
      });
      return;
    }
    self.checkListDownload({
      value: true,
    });
  };

  var checkInformative = function () {
    self.informativeIsPresent =
      self.model.documents &&
      self.model.documents.some(function (element) {
        return element.informative == true;
      });

    self.informativeIsNotPresent =
      self.model.documents &&
      self.model.documents.some(function (element) {
        return element.informative == false;
      });
  };

  var verbaleIsPresentFn = function () {
    self.verbaleIsPresent = self.model.documents &&
      self.model.documents.some(function (element) {
        return element.verbale == true;
      });
  }

  var garanzieIsPresentFn = function () {
    self.garanzieIsPresent = self.model.documents &&
      self.model.documents.some(function (element) {
        return element.garanzia;
      });
  }

  self.sendToMail = function () {
    self.showLoaderSendMail = true;
    $financialApiService
      .getGarToNotify(
        self.model.documents,
        self.financialModel.leasingData.contratto.notificheGaranti,
        self.financialModel.leasingData.id
      )
      .then(function (response) {
        self.renderModal = true;
        self.financialModel.leasingData.contratto.notificheGaranti =
          response.notificheGaranti;
        self.financialModel.leasingData.contratto.notified =
          response.notified;
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("disable");
        $timeout(function () {
          self.showLoaderSendMail = false;
          $("#footerInstant").css("z-index", "-1");
          $(".financial-leasing__footer").css("z-index", "-1");
          $modalService.openModal("sendMail-modal");
        }, 200);
      })
      .catch(function (error) {
        console.log(error);
        self.showLoaderSendMail = false;
      });
  };

  self.closeModal = function () {
    $modalService.closeModal("sendMail-modal");
    $("#footerInstant").css("z-index", "2");
    $(".financial-leasing__footer").css("z-index", "2");
    self.renderModal = false;
  };

  self.check = function (el) {
    el.selected = !el.selected;
  };

  self.sendedMail = function () {
    self.showLoaderSendMail = true;
    $financialApiService
      .notifyGar(
        self.model.documents,
        self.financialModel.leasingData.contratto.notificheGaranti,
        self.financialModel.leasingData.id
      )
      .then(function (response) {
        self.financialModel.leasingData.contratto.notificheGaranti =
          response.notificheGaranti;
        self.showLoaderSendMail = false;
        $modalService.closeModal("sendMail-modal");
        $("#footerInstant").css("z-index", "2");
        $(".financial-leasing__footer").css("z-index", "2");
        self.renderModal = false;
        self.financialModel.leasingData.contratto.mailInviataGaranti = true;
      })
      .catch(function (error) {
        console.log(error);
        self.showLoaderSendMail = false;
        $modalService.closeModal("sendMail-modal");
        $("#footerInstant").css("z-index", "2");
        $(".financial-leasing__footer").css("z-index", "2");
        self.renderModal = false;
        self.financialModel.leasingData.contratto.mailInviataGaranti = false;
      });
  };

  var allDocumentDownloaded = function () {
    if (false) { // in precedenza $portalService.isAra() modificato a seguito della richiesta del mantis 0015494
      self.model.documents &&
        self.model.documents.forEach(function (element) {
          element.downloaded = true;
        });
    }
  };

  self.enableModalButton = function () {
    var enableButton = false;
    var checkSelected = self.financialModel.leasingData.contratto.notificheGaranti.filter(
      function (element) {
        return element.selected;
      }
    );

    if (checkSelected.length) {
      enableButton = checkSelected.every(function (elem) {
        return !!elem.email;
      });
    } else {
      enableButton = false;
    }

    return enableButton;
  };

  var getWizardMap = function (viewIndex) {
    return $rootScope.wizardMap.find(function (element) {
      return element.index == viewIndex;
    }).viewName;
  };

  var checkFileDownloaded = function () {
    if (self.lastMap) {
      if ($portalService.isAru()) {
        self.financialModel.leasingData.contratto.documents.downloadedArc.forEach(
          function (element, index) {
            self.model.documents &&
              self.model.documents.forEach(function (elem) {
                if (elem.cdDoc == element.cdDoc) {
                  elem.downloaded = true;
                }
              });
          }
        );
      } else {
        self.financialModel.leasingData.contratto.documents.downloaded.forEach(
          function (element, index) {
            self.model.documents &&
              self.model.documents.forEach(function (elem) {
                if (elem.cdDoc == element.cdDoc) {
                  elem.downloaded = true;
                }
              });
          }
        );
      }
    } else {
      self.financialModel.leasingData.preventivo.documents.downloaded.forEach(
        function (element, index) {
          self.model.documents &&
            self.model.documents.forEach(function (elem) {
              if (elem.cdDoc == element.cdDoc) {
                elem.downloaded = true;
              }
            });
        }
      );
    }
    everyFileIsDownloaded();
  };

  var notifyEvent = function (documento) {
    if (self.financialModel.leasingData.esitoNotifyEvent) {
      return;
    }

    $notificationService
      .notifyEvent(documento, self.financialModel.leasingData.id.toString())
      .then(function (response) {
        console.log(response);
        self.financialModel.leasingData.esitoNotifyEvent =
          response && response.esito;
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  self.checkStatusOfFile = function () {
    self.listOfInfo = [];
    self.model.documents &&
      self.model.documents.forEach(function (e, index) {
        var status = parseInt(e.status);

        var infoFiles = {
          icon: "",
          visualChek: true,
          visualTrash: true,
          status: 0,
        };
        if (!status) {
          infoFiles.icon = "icon-error text-red";
          infoFiles.visualTrash = true;
          infoFiles.status = 0;
          self.listOfInfo[index] = infoFiles;
          return;
        }

        switch (status) {
          case 1:
            infoFiles.icon = " icon-question-circle1 gray";
            infoFiles.visualTrash = true;
            infoFiles.status = 1;
            self.listOfInfo[index] = infoFiles;
            break;
          case 2:
            infoFiles.icon = "icon-exclamation-circle1 text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 2;
            self.listOfInfo[index] = infoFiles;
            break;
          case 3:
            infoFiles.icon = "icon-error text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 3;
            self.listOfInfo[index] = infoFiles;
            break;
          case 4:
            infoFiles.icon = "icon-flag1 green";
            infoFiles.visualTrash = false;
            infoFiles.status = 4;
            self.listOfInfo[index] = infoFiles;
            break;
          default:
            infoFiles.icon = "icon-error text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 0;
            self.listOfInfo[index] = infoFiles;
            break;
        }
      });
  };

  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (item) {
      self.uploadData = item;
    }
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.isSplit = arguments[4] && arguments[4];
    self.singleFile = self.model.documents[index];
  };

  self.finalUpload = function () {
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    if (!self.isSplit) {
      var url =
        $configService.getAppConfig().url +
        "/uni/upload/service-infos/" +
        encodeURIComponent(self.financialModel.leasingData.preventivo.anno) +
        "/" +
        encodeURIComponent(self.financialModel.leasingData.preventivo.numero) +
        "/FINANCIAL-" +
        self.singleFile.codiceDocNSIL;
    }
    self.disabledForUploadingInProgress = true;
    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    self.loadingStatus.uploading = true;
    var filesUpload = document.querySelector(
      "#uploadInput_document_" + self.currentCodeTypeNameIndex
    ).files;
    filesUpload = Object.keys(filesUpload).map(function (key) {
      return filesUpload[key];
    });
    var formData = new FormData();

    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
    var ndgCliente = self.financialModel.financialCustomer.metadata.riUserG.ndg;
    filesUpload.forEach(function (file) {
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", "FINANCIAL");
      appendToForm(formData, "cdDoc", self.singleFile.cdDocNsil);
      appendToForm(formData, "ndgCliente", ndgCliente);
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.financialModel.leasingData.id);
      appendToForm(formData, "numeroAnno", self.financialModel.leasingData.preventivo.anno);
      appendToForm(formData, "idDocNsil", self.uploadDocumenti.idDocNsil);
      appendToForm(formData, "category", "CUSTOM_CTR");
      appendToForm(formData, "numeroContratto", self.financialModel.leasingData.contratto.numero);
      appendToForm(formData, "modulo", self.financialModel.leasingData.contratto.modulo);
      appendToForm(formData, "cfClient", self.financialModel.financialCustomer.metadata.riUserG.cf);
      appendToForm(formData, "numeroPreventivo", self.financialModel.leasingData.preventivo.numero);


      if (self.uploadDocumenti.owner != "VEN" && self.isLastMap) {
        appendToForm(formData, "digitale", self.financialModel.leasingData.preventivo.firmaDigitale);

      }
      $financialApiService
        .uploadDocOnDigital(formData)
        .then(function (response) {
          if (response.success) {
            $timeout(function () {
              var tmp = {
                filename: file.name,
                id: response.id,
                cdDoc: self.singleFile.cdDocNsil,
                status: "1",
              };

              self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
              self.model.documents[
                self.currentCodeTypeNameIndex
              ].uploadedFiles.push(tmp);
              self.model.documents[self.currentCodeTypeNameIndex].status =
                "1";
              self.disabledForUploadingInProgress = false;
              if (
                $portalService.isAru() &&
                self.financialModel.leasingData.preventivo.completatoArc
              ) {
                self.financialModel.leasingData.preventivo.documents.corrected.push(
                  parseInt(response.id)
                );
              }
              self.checkStatusOfFile();

            }, 1);
          } else {
            self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
            self.disabledForUploadingInProgress = false;
          }
        })
        .catch(function (error) {
          self.disabledForUploadingInProgress = false;
          self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
        });
    });
  };

  self.generateDownloadLink = function (file) {
    if (file.zipMode) {
      return (
        $configService.getUrl() +
        "/uni/downloadGenericDigital/service-infos/FINANCIAL/" +
        encodeURIComponent(file.cdDoc) +
        "/zip/" +
        encodeURIComponent(self.model.idWfInstance) +
        "/?token=" +
        $configService.getAppConfig().token
      );
    } else {
      return (
        $configService.getUrl() +
        "/uni/downloadGenericDigital/service-infos/FINANCIAL/" +
        encodeURIComponent(file.cdDoc) +
        "/" +
        encodeURIComponent(file.id) +
        "/" +
        encodeURIComponent(self.model.idWfInstance) +
        "/?token=" +
        $configService.getAppConfig().token
      );
    }
  };
  self.downloadFile = function (index, file) {
    var input = {
      downloadKey: file.downloadKey
    }
    var url = "/uni/downloadDocDigital/service-infos/"
    $download.getGenericDownload(url, input)
      .then(function (response) {
        self.fileIsDownloaded(index);
      })
  }
  self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    self.disabledForUploadingInProgress = true;
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
    }
    var fileName = fileItem.file.name;
    if (
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".tiff") > -1 ||
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1 ||
      fileName.toLowerCase().indexOf(".p7m") > -1
    ) {
      self.uploader.queue[0].progress = 100;

      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = true;

      $timeout(function () {
        self.progresso = 100;
      }, 500);
    } else {
      fileItem.remove();
      jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
      self.disabledForUploadingInProgress = false;

    }
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disabledForUploadingInProgress = true;
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    self.loadingStatus.uploading = false;
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disabledForUploadingInProgress = false;
    $timeout(function () {
      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
    }, 1);

    fileItem.remove();
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {
      self.uploadOk = true;
      console.log(fileItem);

      var document = {
        fileStatus: null,
        selected: false,
        nameFile: response.uploadFileServicePojo.fileName,
        uuid: "",
        errorMessage: "",
        documentClass: "",
      };

      self.model.documents = response.metadataUniUpload.uploadedfile.sort(
        function (a, b) {
          if (a.codiceDocNSIL > b.codiceDocNSIL) {
            return 1;
          } else {
            return -1;
          }
        }
      );
      self.checkStatusOfFile();

    }
    self.uploader.queue = [];

    $timeout(function () {
      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;

      self.disabledForUploadingInProgress = false;
    }, 1);
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.uploading = false;
  };

  self.deletePrivacyDocument = function (index) {
    self.progresso = 100;

    self.visualProgBarDoc[index] = true;

    $timeout(function () {
      self.progresso = 0;
    }, 200);

    self.documentsToBeDeleted = self.model.documents[
      index
    ].uploadedFiles.filter(function (elem) {
      return elem.selected == true;
    });

    var documentRow =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    self.documentsToBeDeleted.forEach(function (element) {
      if (
        $portalService.isAru() &&
        self.financialModel.leasingData.preventivo.completatoArc
      ) {
        self.financialModel.leasingData.preventivo.documents.refused = self.financialModel.leasingData.preventivo.documents.refused.filter(
          function (elem) {
            return elem != element.id;
          }
        );
      }

      $simulationService
        .deleteChecklistFileDigital(element.id)
        .then(function (response) {
          console.log(response);
          $timeout(function () {
            self.visualProgBarDoc[index] = false;
            self.model.documents[index].uploadedFiles = self.model.documents[
              index
            ].uploadedFiles.filter(function (e) {
              return e.selected != true;
            });
            if (self.model.documents[index].uploadedFiles.length == 0) {
              self.model.documents[index].status = "0";
            }
            self.uploadOk = false;
            self.checkStatusOfFile();

          }, 1);
        })
        .catch(function (error) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_TEC",
          });
          self.checkStatusOfFile();
        });
    });
  };
  self.genericTrashCheck = function (index) {
    return (
      self.model.documents[index] &&
      self.model.documents[index].uploadedFiles &&
      self.model.documents[index].uploadedFiles.some(function (element) {
        return element.selected == true;
      })
    );
  };

  self.printContract = function () {
    $rootScope.$broadcast("pageLoader", {
      action: "OPEN"
    });
    $simulationService.printContract(self.financialModel.leasingData.id)
      .then(function (response) {
        if (response.success) {

          self.recallRestDownload();

        } else {
          $rootScope.$broadcast("pageLoader", {
            action: "CLOSE"
          });
        }
      })
      .catch(function (error) {
        $rootScope.$broadcast("pageLoader", {
          action: "CLOSE"
        });
      })
  }

  self.logDownZip = function () {
    self.showLoaderDownloadZip = true;
    var input = {
      downloadKey: self.downloadSetCtr
    }
    var url = "/uni/downloadSetCtrZip/service-infos/"
    $download.getGenericDownload(url, input)
      .then(function (response) {
        Object.keys(self.listDownload).forEach(function (esternalList) {
          if (esternalList == 'documentsCliAss' || esternalList == 'documentsCliCtr' || esternalList == 'documentsGar' || esternalList == 'documentsVen') {
            self.listDownload[esternalList] &&
              self.listDownload[esternalList].documents &&
              self.listDownload[esternalList].documents.forEach(function (singleFile) {
                singleFile.downloaded = true;
              })
          }
        })
        self.showLoaderDownloadZip = false;
      })
      .catch(function (error) {
        console.error(error);
        self.showLoaderDownloadZip = false;
      })
  }


}